module.exports = __webpack_public_path__ + "static/media/OnPremise.d84169da.svg";